import { render, staticRenderFns } from "./ModalMaterials.vue?vue&type=template&id=7d0accc0&"
import script from "./ModalMaterials.vue?vue&type=script&lang=js&"
export * from "./ModalMaterials.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports